// Copyright (c) 2025 by Audere

export function formatValueAsString(
  value: string | number | boolean | string[]
): string {
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  return value.toString();
}

// Return the first character of each word (in uppercase if letter)
export function getInitials(name: string): string {
  // Split name at whitespaces and hyphens
  const tokens = name.split(/[\s-]+/).filter((token) => token.length > 0);

  return tokens
    .map((token) => token[0])
    .join("")
    .toUpperCase();
}
